export default "/images/vendor/flag-icon-css/flags/1x1/bv.svg?adee14dc818c2a37dbd9f73c21e61ce1";